<div *ngIf="loader" class="container" id="spinerLoader">
  <div class="loader">Loading...</div>
</div>
<div *ngIf="!loader" class="service-request-flags">
  <div mat-dialog-title class="modal_service-header">
    <div class="d-flex justify-content-center align-items-start mx-4 my-5 position-relative header-box">
      <button *ngIf="isAddFlag || isResolved" title="Close" type="button" class="close header-box_cancel-button" (click)="returnToServiceFlag()">
        <i class="fa fa-long-arrow-left"></i> <span class="header-box_cancel-text">Cancel</span>
      </button>
      <h4>{{ isAddFlag ? 'Create New Flag' : isResolved ? 'Resolve Flag' : 'Service Request Flags' }}</h4>
      <button title="Close" type="button" class="close header-box_close" (click)="closeDialog()">
        <i class="fa fa-close"></i>
      </button>
    </div>
  </div>

  <mat-dialog-content>
    <div class="mx-4">
      <ng-container *ngIf="isAddFlag == true">
        <div class="d-flex m-4">
          <form [formGroup]="createServiceRequestFlagForm" (ngSubmit)="saveServiceRequestFlag()" class="create-flag-form-box">
            <div class="label-text">Category <span class="text-danger">*</span></div>
            <ngx-select-dropdown
              id="categoryId"
              name="categoryId"
              class="w-100"
              tabindex="0"
              required
              [class.dropdown-error]="createServiceRequestFlagForm.get('category')?.hasError('required') && createServiceRequestFlagForm.get('category')?.touched"
              [multiple]="false"
              formControlName="category"
              [config]="categoryConfig"
              [options]="categoryList"
              [class.disabled]="!!serviceRequestFlagPayload.srFlagId"
            >
            </ngx-select-dropdown>
            <mat-error *ngIf="createServiceRequestFlagForm.get('category')?.hasError('required') && createServiceRequestFlagForm.get('category')?.touched"
              >Category is required</mat-error
            >
            <div class="d-flex gap-16 mt-4 folowup-time-box">
              <div class="d-flex flex-direction-column">
                <div class="label-text">Follow up date (optional)</div>
                <mat-form-field appearance="outline">
                  <input matInput [matDatepicker]="picker" formControlName="followUpDate" placeholder="__/__/____" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="d-flex flex-direction-column">
                <div class="label-text">Follow up time (optional)</div>
                <mat-form-field appearance="outline" [class.disabled]="!createServiceRequestFlagForm.get('followUpDate')?.value">
                  <input matInput onlyTime formControlName="followUpTime" />
                  <button mat-icon-button matSuffix class="time-icon">
                    <mat-icon>alarm</mat-icon>
                  </button>
                </mat-form-field>
                <mat-error
                  *ngIf="createServiceRequestFlagForm.get('followUpTime')?.errors?.['required'] && createServiceRequestFlagForm.get('followUpTime')?.touched"
                >
                  Time required</mat-error
                >
                <mat-error
                  *ngIf="createServiceRequestFlagForm.get('followUpTime')?.errors?.['minlength'] && createServiceRequestFlagForm.get('followUpTime')?.touched"
                >
                  Time should be in HH:mm format</mat-error
                >
              </div>
            </div>
            <div class="d-flex flex-direction-column mt-4">
              <div class="label-text">Reason & Resolution <span class="text-danger">*</span></div>
              <textarea
                class="service-flag-textarea"
                type="textarea"
                [style.border-color]="
                  createServiceRequestFlagForm.get('reason')?.hasError('required') && createServiceRequestFlagForm.get('reason')?.touched ? '#f44336' : ''
                "
                rows="4"
                placeholder="Provide a reason for this flag and how it can be resolved."
                formControlName="reason"
                [class.disabled]="!!serviceRequestFlagPayload.srFlagId"
              ></textarea>
              <mat-error *ngIf="createServiceRequestFlagForm.get('reason')?.hasError('required') && createServiceRequestFlagForm.get('reason')?.touched"
                >Reason is required</mat-error
              >
            </div>

            <div class="d-flex justify-content-start gap-16 mt-4">
              <button type="button" class="cancel-button" (click)="returnToServiceFlag()">Cancel</button>
              <button type="submit" class="action-button">{{ isUpdateFlag ? 'Update' : 'Create' }} Flag</button>
            </div>
          </form>
        </div>
      </ng-container>
      <ng-container *ngIf="isResolved == true">
        <div class="d-flex flex-direction-column m-4">
          <div class="d-flex gap-16">
            <div class="w-70px resolved-box_title">Category:</div>
            <div class="resolved-box_value d-flex align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path
                  d="M0.0195312 11.8799V0.819336H9.33011L7.34926 3.95738L9.33011 7.08711H1.4487V11.8799H0.0195312Z"
                  [attr.fill]="serviceRequestFlagPayload?.categoryColor"
                />
              </svg>
              <span class="service-flag_text">{{ serviceRequestFlagPayload.category }}</span>
            </div>
          </div>
          <div class="d-flex gap-16 mt-3">
            <div class="w-70px resolved-box_title">Follow up:</div>
            <div class="resolved-box_value">
              <div *ngIf="serviceRequestFlagPayload.followUpTime" class="d-flex">
                <span>{{ serviceRequestFlagPayload.followUpTime | date : 'HH:mm' }} {{ serviceRequestFlagPayload.timezone }},</span>&nbsp;
                <span>{{ serviceRequestFlagPayload.followUpTime | date : 'MM/dd/yyyy' }}</span>
              </div>
              <div *ngIf="!serviceRequestFlagPayload.followUpTime">
                <span>{{ serviceRequestFlagPayload.createdOn | date : 'HH:mm' }} {{ serviceRequestFlagPayload.timezone }},</span>&nbsp;
                <span>{{ serviceRequestFlagPayload.createdOn | date : 'MM/dd/yyyy' }}</span>
              </div>
            </div>
          </div>
          <div class="d-flex gap-16 mt-3">
            <div class="w-70px resolved-box_title">Description:</div>
            <div class="resolved-box_value">{{ serviceRequestFlagPayload.reason }}</div>
          </div>
          <div class="d-flex flex-direction-column mt-5">
            <div class="label-text">Action Taken to Resolve <span class="text-danger">*</span></div>
            <textarea
              class="service-flag-textarea"
              type="textarea"
              maxlength="1000"
              rows="4"
              placeholder="What was the solution?"
              [formControl]="resolutionNote"
            ></textarea>
            <mat-error *ngIf="resolutionNote.hasError('required') && resolutionNote.touched">Enter a resolution note to continue.</mat-error>
          </div>

          <div class="d-flex justify-content-start gap-16 mt-4">
            <button type="button" class="cancel-button" (click)="returnToServiceFlag()">Cancel</button>
            <button type="button" class="action-button" (click)="resolveServiceRequestFlag()">Resolve Flag</button>
            <!-- [class.disabled]="!resolutionNote?.valid"  -->
          </div>
        </div>
      </ng-container>
      <div *ngIf="isAddFlag == false && isResolved == false" class="position-relative">
        <div class="service-info d-flex mb-5">
          <div class="service-info-box box-35 d-flex flex-direction-column">
            <span class="service-info-box_title">Customer</span>
            <span class="service-info-box_value">{{ data.customerName }}</span>
          </div>
          <div class="service-info-box box-15 d-flex flex-direction-column">
            <span class="service-info-box_title">TripID</span>
            <span class="service-info-box_value">{{ data.tripID }}</span>
          </div>
          <div class="service-info-box box-15 d-flex flex-direction-column">
            <span class="service-info-box_title">Type</span>
            <span class="service-info-box_value">{{ data.serviceType }} / {{ data.serviceSubType }}</span>
          </div>
          <div class="service-info-box box-35 d-flex flex-direction-column">
            <span class="service-info-box_title">Status</span>
            <span class="service-info-box_value">{{ data.status }}</span>
          </div>
        </div>
        <div class="position-relative">
          <button
            class="create-flag-btn action-button"
            (click)="addFlag()"
            [class.opacity-0]="isMaxFlagLimit"
            [disabled]="isMaxFlagLimit"
            matTooltipPosition="left"
            [matTooltip]="isMaxFlagLimit ? 'You have reached the maximum number of flags' : ''"
          >
            <i class="fa fa-plus" aria-hidden="true"></i> Create Flag
          </button>

          <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
            <mat-tab *ngFor="let tab of tabs">
              <ng-template mat-tab-label>
                <div class="d-flex">
                  <span>{{ tab.name }} </span>
                  <span class="d-flex align-items-center justify-content-center tab-count ml-2">{{ tab.count }}</span>
                </div>
              </ng-template>
              <ng-container *ngIf="tab.name == flagTypes.Active">
                <ng-container *ngIf="activeFlags?.length; else noData">
                  <table mat-table [dataSource]="activeFlagsDataSource" class="w-100 service-flag-table">
                    <!-- CATEGORY Column -->
                    <ng-container matColumnDef="category">
                      <th mat-header-cell *matHeaderCellDef>
                        <span class="category-header">CATEGORY</span>
                        <span class="category-header-mobile">CATEGORY / FOLLOW UP</span>
                      </th>
                      <td mat-cell *matCellDef="let element" [class.passed-due]="element.isPassedDue" class="category-cell">
                        <div class="d-flex align-items-center customer-box" [class.customer-passed-due]="element.isPassedDue">
                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                            <path
                              d="M0.0195312 11.8799V0.819336H9.33011L7.34926 3.95738L9.33011 7.08711H1.4487V11.8799H0.0195312Z"
                              [attr.fill]="element?.categoryColor"
                            />
                          </svg>
                          <span>{{ element.category | uppercase }}</span>
                        </div>
                        <div *ngIf="element.followUpTime" class="followup-time-category-body mt-1">
                          <span>{{ element.followUpTime | date : 'HH:mm' }} {{ element.timezone }}</span>
                          <span>{{ element.followUpTime | date : 'MM/dd/yyyy' }}</span>
                        </div>
                        <div *ngIf="!element.followUpTime" class="followup-time-category-body mt-1">
                          <span>{{ element.createdOn | date : 'HH:mm' }} {{ element.timezone }}</span>
                          <span>{{ element.createdOn | date : 'MM/dd/yyyy' }}</span>
                        </div>
                      </td>
                    </ng-container>

                    <!-- FOLLOW UP Column -->
                    <ng-container matColumnDef="followUpTime">
                      <th mat-header-cell *matHeaderCellDef class="followup-time-header">FOLLOW UP</th>
                      <td mat-cell *matCellDef="let element" class="followup-time-body" [class.passed-due]="element.isPassedDue">
                        <div *ngIf="element.followUpTime" class="d-flex flex-direction-column" [class.date-passed-due]="element.isPassedDue">
                          <span>{{ element.followUpTime | date : 'HH:mm' }} {{ element.timezone }}</span>
                          <span>{{ element.followUpTime | date : 'MM/dd/yyyy' }}</span>
                        </div>
                        <span *ngIf="!element.followUpTime" class="d-flex flex-direction-column">
                          <span>{{ element.createdOn | date : 'HH:mm' }} {{ element.timezone }}</span>
                          <span>{{ element.createdOn | date : 'MM/dd/yyyy' }}</span>
                        </span>
                      </td>
                    </ng-container>

                    <!-- DESCRIPTION Column -->
                    <ng-container matColumnDef="reason">
                      <th mat-header-cell *matHeaderCellDef>DESCRIPTION</th>
                      <td mat-cell *matCellDef="let element" [class.passed-due]="element.isPassedDue">{{ element.reason }}</td>
                    </ng-container>

                    <!-- ACTIONS Column -->
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef>ACTIONS</th>
                      <td mat-cell *matCellDef="let element" [class.passed-due]="element.isPassedDue">
                        <div class="d-flex flex-direction-column align-items-end">
                          <button class="service-flag-table_actions" [class.passed-due]="element.isPassedDue" (click)="resolveFlag(element)">Resolve</button>
                          <button class="service-flag-table_actions" (click)="addFlag(element)">Edit followup time</button>
                        </div>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="activeFlagsDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: activeFlagsDisplayedColumns"></tr>
                  </table>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="tab.name == flagTypes.Resolved">
                <ng-container *ngIf="resolvedFlags?.length; else noData">
                  <table mat-table [dataSource]="resolvedFlagsDataSource" class="w-100 service-flag-table resolved-flag-table">
                    <!-- CATEGORY Column -->
                    <ng-container matColumnDef="category">
                      <th mat-header-cell *matHeaderCellDef>
                        <span class="category-header">CATEGORY</span>
                        <span class="category-header-mobile">CATEGORY / FOLLOW UP</span>
                      </th>
                      <td mat-cell *matCellDef="let element" class="category-cell">
                        <div class="d-flex align-items-center customer-box" [class.customer-passed-due]="element.isPassedDue">
                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                            <path
                              d="M0.0195312 11.8799V0.819336H9.33011L7.34926 3.95738L9.33011 7.08711H1.4487V11.8799H0.0195312Z"
                              [attr.fill]="element?.categoryColor"
                            />
                          </svg>
                          <span>{{ element.category | uppercase }}</span>
                        </div>
                        <div class="followup-time-category-body mt-1">
                          <span class="resolved-text">{{ element.resolvedOn | date : 'HH:mm' }} {{ element.timezone }}</span>
                          <span class="resolved-text">{{ element.resolvedOn | date : 'MM/dd/yyyy' }}</span>
                        </div>
                      </td>
                    </ng-container>

                    <!-- CREATED BY Column -->
                    <ng-container matColumnDef="createdBy">
                      <th mat-header-cell *matHeaderCellDef class="created-header">CREATED BY</th>
                      <td mat-cell *matCellDef="let element" class="created-body">
                        <div class="d-flex flex-direction-column">
                          <span>{{ element.createdBy }}</span>
                          <span>{{ element.createdOn | date : 'HH:mm' }} {{ element.timezone }}</span>
                          <span>{{ element.createdOn | date : 'MM/dd/yyyy' }}</span>
                        </div>
                      </td>
                    </ng-container>

                    <!-- RESOLVED BY Column -->
                    <ng-container matColumnDef="resolvedBy">
                      <th mat-header-cell *matHeaderCellDef class="resolved-header">RESOLVED UP</th>
                      <td mat-cell *matCellDef="let element" class="resolved-body">
                        <div class="d-flex flex-direction-column">
                          <span>{{ element.resolvedBy }}</span>
                          <span class="resolved-text">{{ element.resolvedOn | date : 'HH:mm' }} {{ element.timezone }}</span>
                          <span class="resolved-text">{{ element.resolvedOn | date : 'MM/dd/yyyy' }}</span>
                        </div>
                      </td>
                    </ng-container>

                    <!-- DESCRIPTION Column -->
                    <ng-container matColumnDef="reason">
                      <th mat-header-cell *matHeaderCellDef>DESCRIPTION</th>
                      <td mat-cell *matCellDef="let element">{{ element.reason }}</td>
                    </ng-container>

                    <!-- RESOLUTION Column -->
                    <ng-container matColumnDef="resolutionNote">
                      <th mat-header-cell *matHeaderCellDef>RESOLUTION</th>
                      <td mat-cell *matCellDef="let element">{{ element.resolutionNote }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="resolvedFlagsDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: resolvedFlagsDisplayedColumns"></tr>
                  </table>
                </ng-container>
              </ng-container>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>

<ng-template #noData>
  <div class="row my-4">
    <div class="d-flex justify-content-center">
      <span class="text-danger"><b>You have no active flags yet. Add a flag to track follow ups on this service request.</b></span>
    </div>
  </div>
</ng-template>
